import { render } from "./ChatInterface.vue?vue&type=template&id=6ab5b9f8&scoped=true"
import script from "./ChatInterface.vue?vue&type=script&lang=js"
export * from "./ChatInterface.vue?vue&type=script&lang=js"

import "./ChatInterface.vue?vue&type=style&index=0&id=6ab5b9f8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab5b9f8"]])

export default __exports__